function asArray<T> (property: T | T[] | undefined): T[] {
  return Array.isArray(property)
    ? property
    : (property === undefined || property === null)
        ? []
        : [property];
}

export function getName (productSchema: any): string | undefined {
  return asArray(productSchema.name)[0];
}

export function getUrl (productSchema: any): string | undefined {
  const url = asArray(productSchema.url)[0];
  return (typeof url === 'string' || !url) ? url : url.id;
}

export function getImageUrl (productSchema: any): string | undefined {
  return asArray(productSchema.image)[0];
}
